module.exports = __webpack_public_path__ + "img/示例图_3.093602cf.png";